/* eslint-disable no-restricted-imports */
import { Deposit } from './actions/deposit';
import { GetPooledEthByShares } from './getters/getPooledEthByShares';
import { GetSharesByPooledETH } from './getters/getSharesByPooledETH';
import { SharesOf } from './getters/sharesOf';
var actions = {
    Deposit: Deposit,
};
var getters = {
    GetSharesByPooledETH: GetSharesByPooledETH,
    GetPooledEthByShares: GetPooledEthByShares,
    SharesOf: SharesOf,
};
var Lido = {
    actions: actions,
    getters: getters,
};
export { Lido };
